module.exports = __webpack_public_path__ + "img/logo.17372f90.png";